module.exports = __webpack_public_path__ + "static/colorpickerfromelement-fa22b3245c7939f159803fda0d568df3.mp4";